import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AccountService } from 'app/account/account.service';
import { LoggerFactory, Logger } from 'app/core/logger.service';
import { SiteSpecific, UserSession } from 'app/core/site-specific.base';
import { SnackBarService } from 'app/core/snack-bar.service';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-site-id-copyable',
  templateUrl: './site-id-copyable.component.html',
  styleUrl: './site-id-copyable.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SiteIdCopyableComponent extends SiteSpecific {
  public loading: boolean;
  private readonly logger: Logger;
  public siteId: number;

  constructor(
    loggerFactory: LoggerFactory,
    protected readonly session: UserSession,
    private readonly AccountService: AccountService,
    private clipboardService: ClipboardService,
    private readonly snackbar: SnackBarService,
  ) {
    super(session, loggerFactory);
    this.logger = loggerFactory.get('ConsentRegistrationComponent');
  }

  protected async onSiteChanged() {
    this.loading = true;
    const account = await this.AccountService.getCurrentAccountAsync();
    this.siteId = account.siteId;
    this.loading = false;
  }
  public copyToClipboard() {
    this.clipboardService.copyFromContent(this.siteId.toString());
    this.snackbar.success('settings.account.site-id.copied');
  }
}
